<template>
    <div class="d-flex flex-column overflow-auto h-100">
        <div class="p-4 flex-grow-1 overflow-auto">
           <div class="mb-3-rem" v-if="this.isMOM">
        <v-label>{{ $t("res_Label_EmailTo") }} <span>*</span></v-label>
        <multiselect
          class="light-bg add-arrow"
          v-model="toEmail"
          :options="emailOptions"
          label="email"
          track-by="email"
          open-direction="bottom"
          :searchable="false"
          :loading="loading"
          :internal-search="false"
          :clear-on-select="false"
          :close-on-select="true"
          :options-limit="300"
          :max-height="600"
          :show-no-results="false"
          :hide-selected="false"
          :multiple="false"
          :placeholder="$t('res_Label_SelectOption')"
        />
      </div>


              <div class="mb-3-rem" v-else>
               <v-label>{{ $t("res_Label_EmailTo") }} <span>*</span></v-label>
                <v-text-field solo v-model='toEmail'></v-text-field>
            </div>
            <div class="mb-3-rem">
               <v-label>{{ $t("res_Label_EmailCC")}}</v-label>
                <v-text-field solo v-model='emailCC'></v-text-field>
            </div>
            <div class="mb-3-rem">
               <v-label>{{ $t("res_Label_Subject") }} <span>*</span></v-label>
                <v-text-field solo v-model='subject'></v-text-field>
            </div>
            <div class="pt-2" style="line-height: 0">
               <v-label>{{ $t("res_Label_Body") }} <span>*</span></v-label>
                <textarea class="text-area" style="height:100px" v-model="body"></textarea>
            </div>
        </div>
        <v-card-actions class="top-shadow gap-3">
            <v-btn class="light-blue flex-1" @click="closeDialog">{{ $t("res_ButtonText_Cancel") }}</v-btn>
            <v-btn class="primary flex-1" @click="sendNotifyEmail">{{ $t("res_ButtonText_SendEmail") }}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    import { McWysiwyg } from '@mycure/vue-wysiwyg'
    import constants from "@/assets/js/constants.js"
    import Multiselect from 'vue-multiselect'
    import axios from "axios"

    export default {
        name: 'NotifyEmail',
        components: { McWysiwyg,Multiselect },
        props: 
        {
			toEmail: { type: String, default: '' },
            emailCC: { type: String, default: '' },
            subject: { type: String, default: ''},
            documentId: { type: Number, default: 0 },
            transferId: { type: Number, default: 0 },
            isMOM: { type: Boolean, default: false},

		},
        data: function () {
            return {
                body: '',
                emailOptions: []
            }
        }, 
        methods: 
        {
            sendNotifyEmail() 
            {
              console.log("sendNotifyEmail")
             console.log(this.documentId)
             console.log(this.transferId)
                if (this.toEmail == '' || this.subject == '' || this.body == '') 
                {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                }
                else 
                {console.log(this.toEmail.email)
                    var emailParam = {
                        toEmail:this.isMOM ? this.toEmail.email : this.toEmail, // toEmail: this.toEmail,
                        body: this.body,
                        subject: this.subject,
                        emailCC: this.emailCC
                    }
                    console.log("emailParam");
                     console.log(emailParam);

                    if (!this.validateEmail(emailParam.toEmail) || !this.validateEmail(emailParam.emailCC)) {
                        window.showAlert(this.$t("res_Msgs_InvalidEmail"), 'warning')
                        return
                    }
                    window.showLoading()
                    var isMOM=this.isMOM;
                    axios.post(constants.baseApiUrl + 'Followup/NotifyEmail?documentId='+this.documentId+'&transferId='+this.transferId+'&isMOM='+isMOM, emailParam, { headers: constants.headers })
                        .then(res => 
                        {
                            if(res.data != null)
                            {
                                window.showAlert('res_Msgs_EmailDispatched', 'success')
                                this.clearData()
                                this.closeDialog() 
                            }
                            else
                            {
                                window.showAlert('res_Msgs_Warning', 'success')
                            }
                        })
                        .catch(err => console.warn(err))
                        .finally(() => window.hideLoading())
                }
            },
            closeDialog() 
            {
                this.$emit('closeDialog')
            },
            clearData() 
            {
                this.toEmail = ''
                this.emailCC = '' 
                this.emailParam = { subject: '', body: '' }
            },
            validateEmail(email) {
                console.log("validateEmail")
                //var email=email;
                email= this.isMOM ? this.toEmail.email : email,
                 console.log(email)
            
                // Check if email contains only spaces
                if (email.trim() === "")
                    return false;

                // Check if email contains '@' character
                if (!email.includes('@'))
                    return false;

                // Check if email contains '@@'
                if (email.includes('@@'))
                    return false;

                // Check if email contains spaces
                if (/\s/.test(email))
                    return false;

                // Split email into local and domain parts
                const [localPart, domainPart] = email.split('@');

                // Check if local part is empty or starts/ends with a dot
                if (!localPart || localPart.startsWith('.') || localPart.endsWith('.'))
                    return false;

                // Check if domain part is empty or starts/ends with a dot
                if (!domainPart || domainPart.startsWith('.') || domainPart.endsWith('.'))
                    return false;

                // Check if domain part contains a dot (to ensure a top-level domain is present)
                if (!domainPart.includes('.'))
                    return false;

                // Regular expression to check for a valid domain
                const domainRegex = /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9]))\.([a-zA-Z]{2,})$/;

                // Regular expression to check for a valid IP address
                const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;

                // Check if domain part is an invalid IP address
                if (domainRegex.test(domainPart) || ipRegex.test(domainPart))
                    return true;
                else
                    return false;
            },
             GetDocumentCommitteeMembersEmails(){
               axios.get(constants.baseApiUrl + 'Document/GetDocumentCommitteeMembersEmails?committeeId='+0 +'&documentId=' + this.documentId)
               
                            .then((res) => {
                                console.log(res.data)
                          
                                this.toEmail = res.data;
                                 console.log("before emailOptions");
                                 if (this.toEmail) {
                                this.emailOptions = this.toEmail.map(email => ({
                                    email: email.trim()  // Clean up any extra spaces
                                }));
                                console.log("emailOptions");
                                console.log(this.emailOptions);  // Debugging to check if options are being populated
                }

                            
                            })
                            .catch(error => console.log(error))
                            .finally(() => window.hideLoading())
        },
        },
        mounted ()  {
           
            
            if(this.isMOM){     
                this.GetDocumentCommitteeMembersEmails()
               
            }

         },
    }
</script>